import { TemplateElement, html } from '@webtides/element-js';
import '../../../../legacy-library/webcomponents/svg-icon/svg-icon';
import '../../../../legacy-library/webcomponents/arrow-box/arrow-box';
import style from './stepper-input.css';
import StepperInputEvents from './StepperInputEvents';

export default class StepperInput extends TemplateElement {
    constructor(options) {
        super({ shadowRender: false, styles: [style], ...options });
    }

    properties() {
        return {
            name: '',
            value: 0,
            min: 1,
            minTooltip: '',
            max: 10,
            maxTooltip: '',
            step: 1,
        };
    }

    watch() {
        return {
            value: (value, oldValue) => {
                this.dispatch(StepperInputEvents.STEPPER_CHANGE, value, true);
                if (value > oldValue) {
                    this.dispatch(StepperInputEvents.STEPPER_INCREASE, value, true);
                } else {
                    this.dispatch(StepperInputEvents.STEPPER_DECREASE, value, true);
                }
            },
        };
    }

    events() {
        return {
            '[ref=down]': {
                click: () => {
                    const currentValue = parseInt(this.$refs.input.value);
                    this.value = Math.max(currentValue - 1, this.min);
                },
            },
            '[ref=up]': {
                click: () => {
                    const currentValue = parseInt(this.$refs.input.value);
                    this.value = Math.min(currentValue + 1, this.max);
                },
            },
        };
    }

    template() {
        return html`
            <div class="flex">
                <button class="btn btn-down" ref="down" ?disabled=${this.value <= this.min}>
                    ${this.minTooltip ? html` <arrow-box class="tooltip"> ${this.minTooltip} </arrow-box> ` : ''}
                    <span>-</span>
                </button>
                <input
                    ref="input"
                    class="input"
                    type="number"
                    id="input-${name}"
                    name="${name}"
                    size="1"
                    value="${this.value}"
                    min="${this.min}"
                    max="${this.max}"
                    step="${this.step}"
                    readonly
                />
                <button class="btn btn-up" ref="up" ?disabled=${this.value >= this.max}>
                    ${this.maxTooltip ? html` <arrow-box class="tooltip"> ${this.maxTooltip} </arrow-box> ` : ''}
                    <span>+</span>
                </button>
            </div>
        `;
    }
}
